import { App } from 'vue';
import servertranslate from '@/utils/servertranslate';
import trim from '@/utils/trim';
import truncate from '@/utils/truncate';
import formatDate from '@/utils/formatDate';

export {
  servertranslate, trim, truncate, formatDate,
};
/* eslint-disable no-param-reassign */
export default {
  install(app: App) {
    app.config.globalProperties.$utils = {
      servertranslate,
      trim,
      truncate,
      formatDate,
    };

    // Optional: for when converting to Composition API
    app.provide('utils', {
      servertranslate,
      trim,
      truncate,
      formatDate,
    });
  },
};
